export default __webpack_public_path__ + "static/media/CNo.65-6.722c7672.jpg";